import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@ibk/shared-auth';
import { selectHasAccessData, selectHasAccessLoading } from '@ibk/shared-config';
import { maskEmail, maskPhone } from '@ibk/shared-utils';
export function useTwoFactorSelect() {
    const { sendToken, logout } = useAuth();
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const hasAccess = useSelector(selectHasAccessData);
    const hasAccessLoading = useSelector(selectHasAccessLoading);
    const availableOptions = [];
    if (hasAccess?.phone_number) {
        availableOptions.push({
            value: 'phone',
            name: 'SMS',
            description: maskPhone(hasAccess.phone_number),
            icon: 'sms',
        });
    }
    if (hasAccess?.email) {
        availableOptions.push({
            value: 'email',
            name: 'E-mail',
            description: maskEmail(hasAccess.email),
            icon: 'email',
        });
    }
    const options = availableOptions;
    const handleContinue = async () => {
        if (!selected)
            return;
        setLoading(true);
        setError(null);
        try {
            const result = await sendToken(selected);
            if (result) {
                navigate('/two-factor-verify', {
                    state: {
                        method: selected,
                        maskedRecipient: result.maskedRecipient,
                    },
                });
            }
            else {
                setLoading(false);
            }
        }
        catch (error) {
            setError('Erro ao enviar token. Tente novamente.');
            setLoading(false);
        }
    };
    const handleBack = () => {
        if (!loading) {
            logout();
            navigate('/login');
        }
    };
    return {
        options,
        selected,
        setSelected,
        loading,
        error,
        setError,
        hasAccessLoading,
        handleContinue,
        handleBack,
    };
}
